module.exports = __webpack_public_path__ + "img/06-silo-base-night.d19244ba.png";